import _ from 'lodash';
import React, { Component, Fragment } from 'react';
import Switch from 'react-switch';
import { inject, observer } from 'mobx-react';
import autobind from 'autobind-decorator';


import SongOptions from './song-options';

@inject('userStore', 'songsStore', 'artistStore')
@observer
class SongRow extends Component {
	@autobind
	parseTime(time) {
        if (_.isNaN(time)) {
            return ("0:00");
        }
        var mins = Math.floor((time / 60)).toFixed(0);
        var secs = Math.floor((time % 60)).toFixed(0);
        return (mins + ":" + (secs < 10 ? "0" : "") + secs);

	}

	render () {
		const {
			songID,
			song,
			active,
			songsStore,
			artistStore,
			onSongClick,
			isPlaying,
			isDisabled,
			trackListMode
		} = this.props;

		if (artistStore.isLoading || songsStore.isLoading) {

			return (<h4>Artist Music Song Row Loading...</h4>);
		}


		const classList = [
			'grid-x',
			'song-row'
		];

		if (isDisabled) {
			classList.push('disabled');
		}


		if(_.isEmpty(song._id)) {
			return null;
		}

		const statusClass = song.status === 'ready' ? 'fi-check' : 'simple-inline-spinner';
		const status = song.status === 'ready' ? song.status :`${song.status || 'Pending'}...`;
		const releaseDate = song.releaseDate;
		const formatedReleaseDate = !isNaN(Date.parse(releaseDate)) ? new Date(releaseDate).toLocaleDateString("en-US") : '';
		// Genre + mood intentionally hidden in the artist CMS until feature
		// extractor accuracy is validated. Re-enable here AND in
		// renderTracksRow's metaItems below when ready.

		if (trackListMode) {
			return this.renderTracksRow({
				isPlaying,
				isDisabled,
				song,
				songsStore,
				onSongClick,
				statusClass,
				status,
				formatedReleaseDate
			});
		}

		const rowStyle = {
			justifyContent: 'space-between',
			alignItems: 'center',
			opacity: isDisabled ? 0.5 : 1,
			pointerEvents: isDisabled ? 'none' : 'auto'
		};

		return (
			<div className={ classList.join(' ') + ` ${isPlaying ? 'currently-playing' : ''}`} style={ rowStyle }>
				<div className="cell shrink" >
					<div style={{width:'2rem', height:'1.7rem'}} className="song-row-counter" data-full-preview-position={ song.fullPreviewPosition }>
						<span className="icon far fa-play-circle" style={{ width: '2rem', height: '2rem', padding: '0.2vh 0 0 0.2vw'}}
						onClick={ () => onSongClick(song, songsStore) }></span>
					</div>
				</div>

				<div className="cell small-7">
					<div
						className="inline"
						onBlur={ this.onEditableBlur }
						ref={ (node) => this.songTitleRef = node }
					>
						{ song.title }
						<br />
						<em style={{fontSize: '1rem', color: 'gray'}}>
							{song.duration}
							{formatedReleaseDate && ` · ${formatedReleaseDate}` }
							{song.additionalArtists && ` · ${song.additionalArtists}`}
							{song.ISRC && ` · ${song.ISRC}`}
						</em>
					</div>
				</div>

				<div className="cell small-1">
					<input
						checked={ Boolean(song.explicit) }
						onChange={ this.onCheckboxChange }
						type="checkbox"
						style={{ width: '50%', marginBottom: 0 }}
					/>
				</div>

				<div className="cell text-center small-1" style={{height: '3.4vh'}}>
					<Switch checked={song.active} height={18} width={38} onColor="#6f3c8a" checkedIcon={false} onChange={this.onSwitchChange} />
				</div>

				<div className={ `cell small-2 song-status-cell ${ song.status }` }>
					<span className={ statusClass }></span>
					{ status }
				</div>

				<div className="cell shrink song-row-actions">
					{ this.renderUserOpts() }
				</div>
			</div>
		);
	}

	@autobind
	renderTracksRow ({
		isPlaying,
		isDisabled,
		song,
		songsStore,
		onSongClick,
		statusClass,
		status,
		formatedReleaseDate
	}) {
		const rowId = song._id || song.id;
		const explicitId = `track-explicit-${ rowId }`;

		const rowClasses = [
			'song-row',
			'song-row-tracks',
			isPlaying ? 'currently-playing' : '',
			isDisabled ? 'disabled' : ''
		].filter(Boolean).join(' ');

		const metaItems = [];

		if (song.duration) {
			metaItems.push({ key: 'length', label: 'Length', value: song.duration });
		}
		if (formatedReleaseDate) {
			metaItems.push({ key: 'release', label: 'Release', value: formatedReleaseDate });
		}
		// Genre + mood intentionally hidden in the artist CMS until feature
		// extractor accuracy is validated.
		if (song.additionalArtists) {
			metaItems.push({ key: 'featuring', label: 'Featuring', value: song.additionalArtists });
		}
		if (song.ISRC) {
			metaItems.push({ key: 'isrc', label: 'ISRC', value: song.ISRC });
		}

		return (
			<div
				className={ rowClasses }
				style={ {
					alignItems: 'center',
					opacity: isDisabled ? 0.5 : 1,
					pointerEvents: isDisabled ? 'none' : 'auto'
				} }
			>
				<div className="song-row-tracks__play">
					<div style={{ width: '2rem', height: '1.7rem' }} className="song-row-counter" data-full-preview-position={ song.fullPreviewPosition }>
						<span
							className="icon far fa-play-circle"
							style={{ width: '2rem', height: '2rem', padding: '0.2vh 0 0 0.2vw' }}
							onClick={ () => onSongClick(song, songsStore) }
							role="button"
							tabIndex={ 0 }
						/>
					</div>
				</div>

				<div className="song-row-tracks__track">
					<div
						className="inline song-row-tracks__title"
						onBlur={ this.onEditableBlur }
						ref={ (node) => this.songTitleRef = node }
					>
						{ song.title }
					</div>
					{ metaItems.length ? (
						<p className="song-row-meta" aria-label="Track details">
							{ metaItems.map(({ key, label, value }, i) => (
								<Fragment key={ key }>
									{ i > 0 ? (
										<span className="song-row-meta__sep" aria-hidden="true">·</span>
									) : null }
									<span className="song-row-meta__item">
										<span className="song-row-meta__label">{ label }</span>
										<span className="song-row-meta__value">{ value }</span>
									</span>
								</Fragment>
							)) }
						</p>
					) : null }
				</div>

				<div className="song-row-tracks__listing">
					<div className="song-row-listing-panel" role="group" aria-label="Listing options">
						<div className="song-row-listing-panel__row">
							<label className="song-row-listing-panel__label" htmlFor={ explicitId }>
								Explicit
							</label>
							<input
								id={ explicitId }
								checked={ Boolean(song.explicit) }
								className="song-row-listing-panel__checkbox"
								onChange={ this.onCheckboxChange }
								type="checkbox"
							/>
						</div>
						<div className="song-row-listing-panel__row">
							<span className="song-row-listing-panel__label" id={ `track-active-label-${ rowId }` }>
								Active
							</span>
							<div className="song-row-listing-panel__switch">
								<Switch
									checked={ song.active }
									checkedIcon={ false }
									height={ 18 }
									onChange={ this.onSwitchChange }
									onColor="#6f3c8a"
									width={ 38 }
								/>
							</div>
						</div>
					</div>
				</div>

				<div className={ `song-row-tracks__status song-status-cell ${ song.status }` }>
					<span className={ `song-row-status-badge song-row-status-badge--${ song.status }` }>
						<span className={ statusClass } />
						{ status }
					</span>
				</div>

				<div className="song-row-tracks__actions song-row-actions">
					{ this.renderUserOpts() }
				</div>
			</div>
		);
	}

	@autobind
	renderUserOpts () {
		const { song, onBlur, trackListMode } = this.props;

		if (_.isEmpty(song)) {
			return null;
		}

		const opts = (
			<SongOptions
				songID={ song._id }
				song={ song }
				optionsTheme={ 'native' }
				onBlur={ onBlur }
			/>
		);

		if (!trackListMode) {
			return (<Fragment>{ opts }</Fragment>);
		}

		return (
			<Fragment>
				<div className="hide-for-medium">
					<SongOptions
						songID={ song._id }
						song={ song }
						optionsTheme="native"
						layout="menu"
						onBlur={ onBlur }
					/>
				</div>
				<div className="show-for-medium">
					<SongOptions
						songID={ song._id }
						song={ song }
						optionsTheme="native"
						layout="inline"
						onBlur={ onBlur }
					/>
				</div>
			</Fragment>
		);
	}

	@autobind
	async saveSong (songToSave) {
		const { userStore, artistStore, } = this.props;
		const user = userStore.getLoggedInUser();
		const artist = artistStore.loggedInArtist;

		await songToSave.save(artist, { silent: true });
		// toast.success('Saved!');
		
	}

	@autobind
	onPlayClick () {
		const { songID, songsStore } = this.props;
		songsStore.setCurrentSong(songID);
	}


	@autobind
	onSwitchChange (value) {
		this.props.song.active = value;
		this.saveSong(this.props.song);
	}
	@autobind
	onCheckboxChange ({ target: { checked } }) {
		this.props.song.explicit = checked;
		this.saveSong(this.props.song);
	}

	@autobind
	onEditableBlur ({ target: { innerHTML: title } }) {
		this.props.song.title = title;
	}
}

export default SongRow;
